import {
  BodyLG,
  BodyMD,
  BodyXL,
  HeadingLG,
  HeadingMD,
} from "../../../typography";

import { GridCardProps } from "../types";
import { cn } from "@verse_core/shared_components/ClassName";

export const GridCard = ({ testimonial, className }: GridCardProps) => (
  <div
    className={cn(
      "tw-flex tw-flex-col tw-justify-between tw-rounded-[1.5em] tw-p-[1.5em] min1040:tw-p-[2em]",
      className,
      testimonial.bgColor,
    )}
  >
    <BodyXL
      className={cn(
        "tw-my-0 min840:tw-hidden min1040:tw-flex",
        testimonial.textColor,
      )}
    >
      "{testimonial.text}"
    </BodyXL>
    <BodyLG
      className={cn(
        "tw-my-0 tw-hidden min840:tw-flex min1040:tw-hidden",
        testimonial.textColor,
      )}
    >
      "{testimonial.text}"
    </BodyLG>
    <div className="tw-flex tw-items-end tw-gap-x-[.75em]">
      {testimonial.imageSrc && (
        <img
          src={testimonial.imageSrc}
          alt={testimonial.author}
          className={cn("tw-h-[3em] tw-w-[3em]", testimonial.avatarClassName)}
        />
      )}
      <div className="tw-flex tw-flex-col tw-gap-y-[.25em]">
        <HeadingLG
          className={cn(
            "tw-my-0 tw-hidden min440:tw-flex",
            testimonial.textColor,
          )}
        >
          {testimonial.author}
        </HeadingLG>
        <HeadingMD
          className={cn(
            "tw-my-0 tw-font-degular min440:tw-hidden",
            testimonial.textColor,
          )}
        >
          {testimonial.author}
        </HeadingMD>
        <BodyMD className={cn("tw-my-0", testimonial.textColor)}>
          {testimonial.role}
        </BodyMD>
      </div>
    </div>
  </div>
);
